import React from 'react';
import { RequestEntity, IItemCustomer } from 'types';
import moment from 'moment';
import Text from 'components/Text/Text';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: IItemCustomer;
	index: number;
}

export const Item: React.FC<IProps> = ({ data, index }) => {
	const nameRowClasses = classNames(style.row, style.name);
	const deletingDateClasses = classNames(style.row, style.deletingDate);
	const userClasses = classNames(style.row, style.user);

	return (
		<div className={style.container} data-test={`Item-${index}`}>
			<div className={nameRowClasses}>
				<div className={style.imgWrapper}>
					<ImgUploaderByEntityId
						resource={RequestEntity.Customers}
						entityID={data.filePath ? data.id : ''}
						photoSize="Small"
						loaderSize="small"
						noImageIdIcon="customerDefaultAvatar"
					/>
				</div>
				<div className={style.customerNameWrapper}>
					<Text className={style.customerName} translationKey={data.name} withTooltip={true} />
				</div>
				<ChunkOfTextWithCopying text={data.id} className={style.copyId} />
			</div>
			<Text
				className={deletingDateClasses}
				translationKey={data.deletedDate ? moment(data.deletedDate).format('MM/DD/YYYY h:mm:ss A') : '-'}
				withTooltip={true}
			/>
			<Text className={userClasses} translationKey={data.deletedBy || '-'} withTooltip={true} />
		</div>
	);
};
